import { createContext, useContext } from 'react';

import type { LDIdentityState } from '@/types/launchDarkly';
import { COLLAPSED_GUEST_IDENTITY } from '@/utils/guestLdIdentity';

export const LaunchDarklyIdentityContext = createContext<LDIdentityState>({
  isIdentified: false,
  guestIdentity: COLLAPSED_GUEST_IDENTITY,
  setIsIdentified: () => {},
});

/** The `isIdentified` boolean, the logout fallback identity, and its setter. */
export const useLaunchDarklyIdentity = () =>
  useContext(LaunchDarklyIdentityContext);

/**
 * Whether the client is identified against a stable randomization unit. False
 * for guests unless `identify-guest-contexts` is on; true for a signed-in
 * customer either way. Anything enrolling a unit in an experiment must gate on
 * this.
 */
export const useIsLaunchDarklyIdentified = () =>
  useLaunchDarklyIdentity().isIdentified;
